import { Component, OnInit, ViewChild } from '@angular/core';
import { Subject, mergeMap, switchMap, takeUntil } from 'rxjs';
import { FeedDto, FeedResponseDto, ParticipantDto } from 'src/app/models/feed.model';
import { FeedService } from 'src/app/services/feed.service';
import { MatSelect } from '@angular/material/select';
import { CurrencyPipe } from '@angular/common';
import { YouthWorkerModel } from 'src/app/models/youth-workers.model';
import { StudentPortalService } from 'src/app/services/student-portal.service';

@Component({
  selector: 'app-feed-view',
  templateUrl: './feed-view.component.html',
  styleUrls: ['./feed-view.component.scss']
})
export class FeedViewComponent implements OnInit {
  private destroyed$ = new Subject();

  feeds: FeedDto[];
  allFeeds: FeedDto[];
  participant: { [key: number]: ParticipantDto} = {};

  @ViewChild('filter', { static: false }) filter: MatSelect;
  selectedView: 'All' | 'My' = 'All';
  youthWorkersData: YouthWorkerModel;

  constructor(private _feedService: FeedService, private _studentPortal: StudentPortalService) { }

  ngOnInit(): void {
    this.getFeedData().pipe(
      takeUntil(this.destroyed$)
    )
    .subscribe((data) => {
      console.log("Feed Data: ", data);
      if(data != null) {
        this.allFeeds = data.feeds.reverse();
        this.participant = data.participants.reduce((prevVal, currVal) => ( {...prevVal, [currVal.id]: currVal}), {});
        this.onViewChanged();
      }
      
    })
    this.getYouthWorkerData().pipe(
      takeUntil(this.destroyed$)
    )
    .subscribe((data) => {
      this.youthWorkersData = data;
      console.log("Youth Worker Data: ", this.youthWorkersData);
    })
  }

  getFeedData()
  {
    return this._feedService.getFeed();
  }

  getYouthWorkerData()
  {
    return this._studentPortal.getYouthWorkers();
  }

  getFeedParticipant(feed: FeedDto)
  {
    return this.participant[feed.authorUserId];
  }

  onViewChanged() {
    this.feeds = this.selectedView === 'All' ? this.allFeeds : this.allFeeds.filter((f) => f.authorPersonId == this.youthWorkersData.primary.staffId)
    // console.log(this.selectedView);
  }

  ngOnDestroy()
  {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
